import { ACTIVE_SERVER_ID } from 'mk/settings';
import { ID_RE, SLUG_RE } from 'mk2/helpers/urls';

const STROLLER_SLUG = `:slug(${SLUG_RE})`;
const BRAND_SLUG = `:slug(${SLUG_RE})`;
const STROLLER_PHOTO_ID = `:photoId([sr]${ID_RE})`;

const strollersPrefixes = {
    201: 'kocikopedia',
    202: 'kocarkopedie',
};
export const strollersPrefix = strollersPrefixes[ACTIVE_SERVER_ID];

export const strollersUrl = `/${strollersPrefix}/`;

export const strollersSearchUrl = `${strollersUrl}search/:pageMode(edit|results|all)/`;

export const strollersWishlistUrl = `${strollersUrl}wishlist/`;
export const strollersChartsUrl = `${strollersUrl}charts/`;

export const strollersBrandsUrl = `${strollersUrl}brands/`;
export const strollersListUrl = `${strollersUrl}brand/${BRAND_SLUG}/`;

export const strollersWikiUrl = `${strollersUrl}w/:articleSlug(${SLUG_RE})/`;
export const strollersDetailUrl = `${strollersUrl}${STROLLER_SLUG}/`;
export const strollersPhotoUrl = `${strollersDetailUrl}image/${STROLLER_PHOTO_ID}/`;
export const strollersAddReviewUrl = `${strollersDetailUrl}add_review/`;
export const strollersAddReviewScoreUrl = `${strollersDetailUrl}add_review/:screen(score)/`;
export const strollersReviewsUrl = `${strollersDetailUrl}reviews/`;

export const strollersAddQuestionUrl = `${strollersDetailUrl}add_question/`;

export const strollersDetailAlternateUrl = (server) => `/${strollersPrefixes[server]}/${STROLLER_SLUG}/`;
